import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "styled-components";

/* import utils */
import { filterString, maskCurrencyReal, getDate, maskCurrencyRealtoCalc } from "./../../util/functions";
import { NotifyContext } from "./../../util/notify";

/* import services */
import api from "./../../services/api";

import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";

/* import components */
import Legend from "./../../components/Legend";
import Search from "./../../components/Search";
import Input from "./../../components/Form/Input";
import Select from "./../../components/Form/Select";

/* import icons */
import IncomeIcon from "./../../assets/icons/income";

/* import styles */
import { Container, Cards, Card, Title, Subtitle, Comment, AddButton, FormModal, FormGroup } from "./styles";

export default function PartnerSegment({ toggleTitles }) {
  toggleTitles("Segmento de Parceiros", "Gerenciamento dos segmentos dos parceiros");

  const { status: colors } = useContext(ThemeContext);
  const { notify } = useContext(NotifyContext);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [modalOpen, setModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("");

  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);

  const [titleModal, setTitleModal] = useState("Novo Segmento");

  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [is_active, setIs_active] = useState(true);

  const handleFilter = async text => {
    const filtered = initialData.filter(
      item =>
        filterString(item.is_active ?? false, (searchStatus === "inative" ? false : true) ?? "") &&
        (filterString(item.id, text) || filterString(item.name, text)),
    );
    setData(filtered);
  };

  const handleClearForm = event => {
    event.preventDefault();

    setTitleModal("Editar segmento");

    setId("");
    setName("");
    setIs_active(true);
  };

  const handleNewItem = () => {
    setTitleModal("Novo segmento");

    setId("");
    setName("");
    setIs_active(true);

    setModalOpen(true);
  };

  const handleOpenModalEdit = async (p_id, p_name, p_is_active) => {
    setTitleModal("Editar segmento");

    setId(p_id);
    setName(p_name);
    setIs_active(p_is_active);
    setModalOpen(true);
  };

  const handleSave = async event => {
    event.preventDefault();

    try {
      if (!id) {
        await api.post(`/partners/segments/`, { name, is_active });
        notify.show(true, "Registro adicionado com sucesso", "success");
      } else {
        await api.put(`/partners/segments/${id}`, { name, is_active });
        notify.show(true, "Registro atualizado com sucesso", "success");
      }

      loadData();
      setModalOpen(false);
    } catch (error) {
      console.log(error);
      notify.show(true, "Erro ao salvar registro! Tente novamente", "error");
    }
  };

  async function loadData() {
    try {
      const { data } = await api.get(`/partners/segments/panel`, {});
      await setInitialData(data);
      await setData(data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleFilter(searchValue);
  }, [searchStatus]);

  useEffect(() => {
    loadData();
    document.querySelector("#input").focus();
  }, []);

  return (
    <>
      <Container>
        <Legend
          active={searchStatus}
          onClick={status => {
            setSearchStatus(status);
          }}
          items={[
            {
              key: "status",
              value: "active",
              title: "Filtrar Ativos",
              color: colors["active"],
            },
            {
              key: "status",
              value: "inative",
              title: "Filtrar Inativos",
              color: colors["inative"],
            },
          ]}
        />

        <Cards>
          {data.map(({ id, name, color, is_active }) => {
            return (
              <Card
                onClick={() => {
                  handleOpenModalEdit(id, name, is_active);
                }}
                status={colors[is_active ? "active" : "inative"]}
                key={id}>
                <Title>{name}</Title>
                {/*<Subtitle>{uri}</Subtitle>*/}
                <Comment>{is_active ? "ATIVO" : "DESATIVADO"}</Comment>
              </Card>
            );
          })}
        </Cards>

        <Search
          InitialValue={searchValue}
          onChange={text => {
            setSearchValue(text);
            handleFilter(text);
          }}
        />

        <AddButton onClick={() => handleNewItem()}>
          <IncomeIcon width="21" heigth="21" /> Novo Segmento
        </AddButton>
      </Container>

      <Dialog
        fullScreen={fullScreen}
        open={modalOpen}
        onClose={event => {
          handleClearForm(event);
          setModalOpen(false);
        }}
        aria-labelledby="responsive-dialog-title">
        <DialogTitle id="responsive-dialog-title">{titleModal}</DialogTitle>
        <DialogContent>
          <FormModal onSubmit={handleSave}>
            <FormGroup>
              <Input
                id="name"
                name="name"
                label="Nome"
                tabIndex={101}
                type="text"
                initialValue={name}
                onChange={text => {
                  setName(text);
                }}
                required={true}
              />

              <Select
                id="is_active"
                name="is_active"
                label="Situção"
                tabIndex={102}
                initialValue={is_active}
                onChange={text => {
                  setIs_active(text);
                }}
                options={[
                  { value: "", text: "Selecione" },
                  { value: true, text: "Ativo" },
                  { value: false, text: "Inativo" },
                ]}
                multiple={false}
                required={true}
              />
            </FormGroup>

            <button id="btnFormSubmit" style={{ display: "none" }}>
              enviar
            </button>
          </FormModal>
        </DialogContent>

        <DialogActions>
          <Button
            tabIndex={108}
            onClick={event => {
              handleClearForm(event);
              setModalOpen(false);
            }}
            color="secondary">
            Cancelar
          </Button>
          <Button tabIndex={107} color="primary" onClick={() => document.querySelector("#btnFormSubmit").click()}>
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
